<template>
  <select-dict v-model="colorCode" :select-list="finishColors" :disabled="isDisabledSelect" />
</template>

<script setup lang="ts">
import { computed, defineModel, watch } from "vue";

import SelectDict from "@/components/UI/SelectDict.vue";
import { useDictStore } from "@/stores/dictStore";

type FinishColorSelectProps = {
  installedSystemCode: string;
};

const props = defineProps<FinishColorSelectProps>();
const dictStore = useDictStore();
const isDisabledSelect = computed(() => !props.installedSystemCode);

const colorCode = defineModel<string>({ default: "black" });
const finishColors = computed(() =>
  dictStore.getFinishColors(props.installedSystemCode),
);

watch(
  () => props.installedSystemCode,
  (newVal, oldVal) => {
    if (oldVal && newVal) {
      colorCode.value = "";
    }
  }, {
  immediate: true,
}
);
</script>

<style lang="scss" scoped></style>
